import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Rol } from './roles.model';

@Injectable({
  providedIn: 'root'
})
export class RolService {
  url: string;
  token: string;
  endpoint = 'roles';

  constructor(private http: HttpClient) {}

  getRoles(): Observable<Rol[]> {
    return this.http.get<Rol[]>(`${this.url}/${this.endpoint}/`, {
      params: { token: this.token }
    });
  }

  addRol(roles: Rol): Observable<Rol> {
    return this.http.post<Rol>(`${this.url}/${this.endpoint}/`, {
      ...roles
    });
  }

  changeRol(r: Rol): Observable<Rol> {
    const fecha_baja = r.fecha_baja
      ? r.fecha_baja.toString().split('T')[0]
      : null;
    
    // Si tiene fecha_baja, no enviar acreditacion_representacion
    let payload = { ...r };
    if (fecha_baja) {
      // Usar destructuring para excluir acreditacion_representacion
      const { acreditacion_representacion, ...rolSinAcreditacion } = r;
      payload = rolSinAcreditacion;
    }
    
    return this.http.patch<Rol>(`${this.url}/${this.endpoint}/${r.id}/`, {
      ...payload,
      fecha_baja: fecha_baja
    });
  }

  deleteRol(p: Rol): Observable<Rol> {
    return this.http.delete<Rol>(`${this.url}/${this.endpoint}/${p.id}/`);
  }
}
